import { sortObjectRoot } from "global/common/sorting";
import { appIconTypes } from "global/enums/appIconTypes"
import { gEnums } from "global/enums/globalEnums";
import _ from 'lodash'
import { useCallback } from "react";

const _isPersonProps = ['attendees', 'golfers', 'reservations', 'speakers', 'guests', 'staff', 'reservations'];
const _isScheduleProps = ['sessions'];
const _sectionProps = {
  address: ['city', 'state', 'zip', 'street', 'address'],
  contact: ['email', 'phone', 'cellPhone', 'businessPhone', 'officePhone', 'mobilePhone', 'phoneNumber', 'cellPhoneNumber', 'businessPhoneNumber', 'officePhoneNumber', 'mobilePhoneNumber'],
  description: ['description'],
  hidden: ['key', 'sv', 'itemKey', 'gsid', 'svs', '_gsid', '_itemKey', 'key', 'sv', 'svs', 'sv*', 'svs*'],
  image: ['image', 'imageUrl'],
  location: ['location', 'locations'],
  name: ['firstName', 'lastName', 'middleName', 'suffix', 'name', 'prefix', 'salutation'],
  pinned: ['description', 'descriptions', 'bio', 'aboutMe'],
  schedule: ['date', 'startDate', 'endDate', 'startTime', 'departureTime', 'endTime', 'startDateUTC', 'startDateUtc', 'endDateUTC', 'endDateUtc', 'startTimeUTC', 'startTimeUtc', 'endTimeUTC', 'endTimeUtc'],
  social: ['facebook', 'twitter', 'instagram', 'snapchat', 'tiktok'],
  tagged: ['company', 'locations', 'location', 'registrationTypes', 'title', 'companyName'],
  travel: ['checkInDate', 'checkOutDate', 'checkIn', 'checkOut', 'hotel', 'confirmationNumber'],
  tags: ['tags'],
};
const _globalPeople = ['attendees', 'speakers', 'staff', 'guests', 'staff'];

export const useCreateItems = () => {

  const createGlobal = useCallback((eventData) => {
    return _createGlobal(eventData)
  }, []);

  const createViewItem = useCallback((viKey, options) => {
    return _createViewItem(viKey, options)
  }, []);

  const createView = useCallback((key, viList, isList) => {
    return _createView(key, viList, isList)
  }, []);

  const createViews = useCallback((viewItems, existingViews, createClient, newProps) => {
    return _createViews(viewItems, existingViews, createClient, newProps)
  }, []);

  const createViewItemProps = useCallback((propsToAdd, existingProps, propSection) => {
    return _createViewItemProps(propsToAdd, existingProps, propSection)
  }, []);

  const createViewItemPropSections = useCallback((name, count, propSections) => {
    return _createViewItemPropSections(name, count, propSections)
  }, []);

  const addPropItem = useCallback(async (name, selectedKey, viewItems_app, views_app) => {
    const propsToAdd = { [name]: { key: name } }
    const vi = selectedKey.split('.')[0]
    const vips = viewItems_app[vi].props
    const viprs = viewItems_app[vi].propSections
    const propPropSection = _ammendSectionName(name) || 'details'
    console.log('propPropSection', name, propPropSection)

    // propsToAdd, existingProps, propSection
    await createViewItemProps(propsToAdd, vips, propPropSection)

    _.forEach(views_app, (view, viewKey) => {
      const { viewItems } = view ?? {}
      _.forEach(viewItems, async (viewItem, viewItemKey) => {
        if (viewItemKey === vi) {
          const vipss = viewItem?.props
          await createViewItemProps(propsToAdd, vipss, propPropSection)
        }
      })
    })

    if (!viprs?.[propPropSection]) {
      await addPropSection(propPropSection, selectedKey, viewItems_app, views_app)
    }

  }, []);

  const addPropSection = useCallback(async (name, selectedKey, viewItems_app, views_app) => {

    const vi = selectedKey.split('.')[0]
    const viprs = viewItems_app[vi].propSections

    await createViewItemPropSections(name, _.size(viprs), viprs)

    _.forEach(views_app, (view, viewKey) => {
      const { viewItems } = view ?? {}
      _.forEach(viewItems, async (viewItem, viewItemKey) => {
        if (viewItemKey === vi) {
          viewItem.propSections = viprs
        }
      })
    })

  }, []);

  const addViewItem = useCallback(async (name, viewItems_app, views_app) => {
    const viewItems_new = createViewItem(name, { forGlobal: true, createGenericProps: true, createPropSections: true, count: _.size(viewItems_app) + 1 })
    viewItems_app[name] = viewItems_new
    const nv = createViews(viewItems_app, views_app)
    _.forEach(nv, (nvi, nvik) => {
      views_app[nvik] = nvi
    })
  }, []);

  const copyViewItem = useCallback(async (d, viewItems_app, views_app) => {
    const viewItems_copy = _.cloneDeep(viewItems_app?.[d.copyFrom])
    viewItems_copy.key = _.camelCase(d.name)
    _.set(viewItems_copy, 'dataSource.dataCollectionName', d.copyFrom)
    _.set(viewItems_copy, 'display.caption', _.startCase(d.name))
    // viewItems_copy.dataSource.dataCollectionName = d.name
    // viewItems_copy.display.caption = _.startCase(d.name)
    // const viewItems_copy = create_fns.createViewItem(d.name, { forGlobal: true, createGenericProps: true, createPropSections: true, count: _.size(viewItems_app) + 1 })

    console.log('viewItems_copy', viewItems_copy)
    viewItems_app[d.name] = viewItems_copy
    const nvc = createViews(viewItems_app, views_app)
    _.forEach(nvc, (nvi, nvik) => {
      views_app[nvik] = nvi
    })
  }, []);

  return {
    createGlobal,
    createViewItem,
    createView,
    createViews,
    createViewItemProps,
    createViewItemPropSections,
    addPropItem,
    addPropSection,
    addViewItem,
    copyViewItem,
  };

};

const _createGlobal = ({ eventData }) => {
  const _global = {
    eventOptions: {
      allowEmailLinks: true,
      allowPhoneLinks: true,
      allowUrlLinks: true,
    },
    appDataSource: {
      appDataSourceType: gEnums.dataSourceTypes.firebase,
      autoUpdateCollectionRelationships: true,
      autoUpdateAppDataLinks: true,
      autoUpdateAppDataDocuments: true,
      autoUpdateStaticViews: true,
      useAppDataDocuments: true,
      useAppDataLinks: true,
      appDataLinkType: gEnums.appDataLinkTypes.all,
    },
    appSettings: {
      showOptionsFromLongPress: true,
    },
    appSignIn: {
      authGlobalPassword: 'meevents_current',
      allowEmail: true,
      allowEmailLink: true,
      allowPhone: true,
      allowPasswordReset: true,
    },
    appUserImageOptions: { // WAS appUserSettings
      useClientProfileImage: true,
    },
    appUserUiOptions: { // WAS appUserSettings
      allowCloning: true,
      myProfileCaption: 'My Profile',
      myProfileIcon: 'user',
      myProfileIconLocation: gEnums.iconLocations.first,
      showMyProfileLinkOnHomeScreen: true,
    },
    appUserDataSettings: {
      appUserCollection: 'attendees',
      appUserCollections: ['attendees'],
      appUserViewTypeProp: 'registrationType',
      appUserPages: ['events'],
    },
    appUserSettings: {
      appUserPersonalPages: ['notifications'],
      appUserPrivacyPages: ['notificationSettings'],
      groupAppUserPages: true,
      groupCaption: 'My Info',
      showAppUserPersonalPages: true,
      showAppUserPrivacyPages: true,
    },
    appUserPageSettings: {
      groupAppUserPages: true,
      groupedCaption: 'Profile',
      groupType: gEnums.displayDirectionTypes.vertical,
    },
    navigation: {
      includeHome: true,
      includeSlideout: true,
      showNavigation: true,
    },
    dataOptions: {
      dataFormat: gEnums.dateTypes.shortestDate,
      dataLimit: 200,
      hideInactiveItems: true,
      limitDevelopmentData: true,
      useItemStatus: true,
      useTimestamps: true,
    },
    display: {
      hideArrays: true,
      hideEmptySections: true,
      urlText: 'Open Link',
    },
    formatting: {
      dateFormat: 'shortDate',
      dateMenuFormat: 'shorterDate',
      timeFormat: 'ampm',
    },
    googleSheetsImportOptions: {
      allowMultiColumnArrays: true,
      allowSingleColumnArrays: true,
      convertIdsToFirebaseKeys: true,
      singleColumnArraySeparator: ';',
    },
    manifest: {
      name: eventData?.name ? eventData.name : 'name',
      shortName: eventData?.name ? createInitials(eventData.name) : 'INI',
      display: gEnums.manifestDisplayTypes.standalone,
      appleTouchIcon72: 72,
      appleTouchIcon120: 128,
      appleTouchIcon152: 152,
      appleStartUpImage: 72,
    },
    groupingOptions: {
      alphaDisplayType: gEnums.alphaDisplayTypes.vertical,
      alphaFilterType: gEnums.alphaFilterTypes.afterLimit,
      alphaFilterAfter: 50,
      applyToCollections: _globalPeople,
      restrictToExisting: true,
      showAlphaCount: true,
      showFullAlphaList: true,
      useGlobalAlphabetSettings: true,
      useVerticalHidden: true,
      verticalOpacity: gEnums.opacityTypes.dark,
    },
    imageOptions: {
      collectionImageCollections: _globalPeople,
      imageLocation: gEnums.imageLocations.left,
      imageSize: gEnums.imageSizes.medium,
      imageType: gEnums.imageTypes.bordered,
      showDefaultImage: true,
      useGlobalImageSettings: true,
      useClientProfileImage: true,
    },
    imageMapping: {
      allowCollectionMapping: true,
      locationProps: ['locations'],
      collectionNames: ['sessions'],
      showImageMap: true,
      useImageMapIcon: true,
      useGlobalImageSettings: true,
      useClientProfileImage: true,
    },
    dataModifications: {
      add: {
        allowAction: true,
        accessLevel: gEnums.accessLevels.appSubAdmin,
      },
      bulkImageUpload: {
        allowAction: true,
        accessLevel: gEnums.accessLevels.appDataAdmin,
      },
      edit: {
        allowAction: true,
        accessLevel: gEnums.accessLevels.appDataAdmin,
      },
      filters: {
        allowAction: true,
        accessLevel: gEnums.accessLevels.appDataAdmin,
      },
      images: {
        allowAction: true,
        accessLevel: gEnums.accessLevels.appDataAdmin,
      },
      modifyList: {
        allowAction: true,
        accessLevel: gEnums.accessLevels.appDataAdmin,
      },
      sorting: {
        allowAction: true,
        accessLevel: gEnums.accessLevels.appDataAdmin,
      },
      status: {
        allowAction: true,
        accessLevel: gEnums.accessLevels.appDataAdmin,
      },
    },
    sideMenu: {},
    settingsOptions: {
      showSettingsInBlocks: true,
      sortGroupsByPermission: true,
      sortMenuItemsByPermission: true,
      useDarkMode: true,
    },
    settingsPermissions: {
      allowCopySettings: true,
      allowHiddenIcons: true,
      allowResetSettings: true,
    },
    storageOptions: {
      clientStorageImageCollections: _globalPeople,
      saveCollectionImagesToClient: true,
    },
    themeColors: eventData ? { ...eventData.themeColors } : {},
    themedItems: {
      background: {
        gap: gEnums.marginTypes.normal,
      },
      gridIcons: {
        gap: gEnums.marginTypes.normal,
        size: gEnums.sizeTypes.normal,
        iconSize: gEnums.sizeTypes.normal,
      },
      topMenu: {
        fontWeight: gEnums.fontWeightTypes.bolder,
        size: gEnums.sizeTypes.large,
      },
    },
    topMenu: {
      menuLocation: gEnums.menuLocations.top,
      mainCaptionSource: gEnums.menuCaptionSources.fixed,
      mainDataPage: 'events',
    },
    transitionItems: {
      component: {
        duration: .4,
        opacityValue: 8,
        scaleValue: 9.8,
        useOpacity: true,
        useTransitions: true,
      },
      data: {
        duration: .2,
        opacityValue: 8,
        scaleValue: 9.8,
        useOpacity: true,
        useScale: false,
        useTransitions: false,
      },
      fullPageWrapper: {
        duration: .2,
        opacityValue: 9,
        useOpacity: true,
        useTransitions: true,
      },
      image: {
        duration: .6,
        opacityValue: 8,
        scaleValue: 9.8,
        useOpacity: true,
        useScale: true,
        useTransitions: true,
      },
      page: {
        duration: .5,
        opacityValue: 8.0,
        scaleValue: 9.6,
        useOpacity: true,
        useScale: true,
        useTransitions: true,
      },
      pageItem: {
        duration: .5,
        opacityValue: 8.0,
        scaleValue: 9.6,
        useOpacity: true,
        useScale: true,
        useTransitions: true,
      },
      pageItemElement: {
        duration: .2,
        opacityValue: 8,
        scaleValue: 9.8,
        useOpacity: true,
        useScale: false,
        useTransitions: false,
      },
      topBanner: {
        duration: .8,
        opacityValue: 8,
        scaleValue: 9.1,
        useOpacity: true,
        useTransitions: true,
      },
    },
    uiSections: {
      header: {
        apply: true,
        fontWeight: 'bolder',
        size: 'large',
      },
      sectionHeader: {
        apply: true,
        fontWeight: gEnums.fontWeightTypes.bold,
        headerDisplayType: gEnums.sectionHeaderTypes.divider,
      },
      sectionBody: {
        apply: true,
        captionWidth: gEnums.captionWidths.normal,
        bodyDisplayType: gEnums.sectionBodyTypes.table,
        opacity: gEnums.opacityTypes.dark,
      },
    },
  };
  return _global
}

const _createViewItem = (viKey, options = {}) => {
  const {
    forGlobal = false,
    count,
    forList = false,
    forAdditional = false,
    forMain = false,
    createGenericProps = false,
    createPropSections = false,
    existingViewItem,
    newProps,
    fullProps,
    addKey = false,
    directReturn = false,
    isPks,
    dcn,
  } = options


  const defaultIcon = appIconTypes[viKey] || 'file alternate'
  let caption = _.startCase(viKey)
  let show = true
  let showDesktop = true

  // ------------------------
  // Visibility rules
  // ------------------------
  if (!forGlobal && viKey === 'events') {
    show = createGenericProps
    showDesktop = false
  }

  if (viKey.toLowerCase().endsWith('types')) {
    show = false
  }

  // ------------------------
  // Sort prop
  // ------------------------
  let sortProp = _isPersonProps.includes(viKey) ? 'lastName' : 'name'
  if (_isScheduleProps.includes(viKey)) {
    sortProp = 'startTime'
  }

  // ------------------------
  // Caption override (non-global)
  // ------------------------
  if (!forGlobal && !forList && !forAdditional && !forMain) {
    caption = 'About'
  }

  let viewItem = {}

  // ======================================================
  // ===================== GLOBAL =========================
  // ======================================================
  if (forGlobal) {
    viewItem = {
      show,
      showDesktop,
      position: count,
      dataConnection: {
        dataSourceType: gEnums.dataSourceTypes.firebase,
        dbFetchType: gEnums.dbFetchTypes.realtime,
        firestoreType: gEnums.firestoreTypes.firestore,
        firebaseType: gEnums.firebaseTypes.cloudFirestore,
        uniqueProps: _getUniqueProps(viKey),
      },
      display: {
        caption,
        defaultIcon,
        displayType: gEnums.displayTypes.card,
        cardDisplayType: _getCardDisplayType(viKey),
        sortProp,
      },
      desktopDisplay: {
        caption,
        defaultIcon,
        displayType: gEnums.displayTypes.card,
        cardDisplayType: _getCardDisplayType(viKey),
        sortProp,
      },
      props: {},
      propSections: {},
    }

    if (isPks) {
      viewItem.isPks = isPks
    }

    // ------------------------
    // Dependencies
    // ------------------------
    switch (viKey) {
      case 'clients':
        viewItem.dataConnection.dependencies = []
        break
      case 'events':
        viewItem.dataConnection.dependencies = ['clients']
        break
      default:
        viewItem.dataConnection.dependencies = ['clients', 'events']
    }

    // ------------------------
    // Generic props
    // ------------------------
    if (createGenericProps) {
      switch (viKey) {
        case 'attendees':
        case 'profiles':
        case 'staff':
        case 'speakers':
          viewItem.props.name = _createViewItemProp('name', _ammendSectionName('name'))
          viewItem.props.lastName = _createViewItemProp('lastName', _ammendSectionName('name'))
          viewItem.props.firstName = _createViewItemProp('firstName', _ammendSectionName('name'))
          viewItem.props.email = _createViewItemProp('email', _ammendSectionName('name'))
          viewItem.props.title = _createViewItemProp('title', _ammendSectionName('name'))
          viewItem.props.company = _createViewItemProp('company', _ammendSectionName('name'))
          break

        default:
          viewItem.props.name = _createViewItemProp('name', _ammendSectionName('name'))
          viewItem.props.description = _createViewItemProp(
            'description',
            _ammendSectionName('description')
          )
      }
    }

    // ------------------------
    // newProps
    // ------------------------
    if (_.isArray(newProps)) {
      newProps.forEach((prop) => {
        viewItem.props[prop] = _createViewItemProp(prop, _ammendSectionName(prop))
      })
    }

    // ------------------------
    // fullProps
    // ------------------------
    if (fullProps) {
      _.forEach(fullProps, (v, key) => {
        viewItem.props[key] = _createViewItemProp(key, _ammendSectionName(key))
      })
    }

    // ------------------------
    // Prop sections
    // ------------------------
    if (createPropSections) {
      viewItem.propSections.name = _createViewItemPropSection('name', 0, null, viKey)
      // viewItem.propSections.details = _createViewItemPropSection('details', 1, null, viKey)
      viewItem.propSections.description = _createViewItemPropSection(
        'description',
        2,
        null,
        viKey
      )
    }

    // ======================================================
    // =================== NON-GLOBAL ========================
    // ======================================================
  } else {
    viewItem = existingViewItem || {
      show,
      showDesktop,
      position: count,
      display: {
        caption,
        defaultIcon,
        displayType: gEnums.displayTypes.card,
        ignoreTaggedProps: true,
        cardDisplayType: _getCardDisplayType(viKey, forList, forAdditional),
        sortProp,
      },
      desktopDisplay: {
        caption,
        defaultIcon,
        displayType: gEnums.displayTypes.card,
        cardDisplayType: _getCardDisplayType(viKey, forList),
        sortProp,
      },
      props: existingViewItem ? existingViewItem.props : {},
      propSections: existingViewItem ? existingViewItem.propSections : {},
    }

    if (fullProps) {
      viewItem.props = fullProps
    }


    // ------------------------
    // Data source
    // ------------------------
    if (!viewItem.dataSource) {
      viewItem.dataSource = {
        dataSourceType: gEnums.dataSourceTypes.firebase,
        dataCollectionName: dcn || viKey,
      }
    }

    // ------------------------
    // Additional constraints
    // ------------------------
    if (forAdditional && !forMain && !viewItem.dataConstraints) {
      viewItem.dataConstraints = {
        usePageConstraint: true,
        usePostPageConstraint: true,
        pageConstraintType: gEnums.pageConstraintTypes.arrayContains,
      }
    }

    // ------------------------
    // Grouping rules
    // ------------------------
    switch (viKey) {
      case 'attendees':
      case 'reservations':
      case 'speakers':
        if (forList) {
          viewItem.grouping = {
            alphabetActive: true,
            alphaDisplayType: gEnums.alphaDisplayTypes.tab,
            alphaFilterType: gEnums.alphaFilterTypes.afterLimit,
            alphaFilterAfter: 50,
            alphaProp: 'lastName',
            restrictToExisting: true,
          }
        }
        break

      case 'sessions':
        viewItem.grouping = {
          groupActive: true,
          groupType: gEnums.groupTypes.swipeableTab,
          groupByProp: 'startDate',
        }
        break
    }
  }

  // ------------------------
  // Final key
  // ------------------------
  if (addKey) {
    viewItem.key = viKey
  }

  return viewItem
}

const _createView = (key, viList, isList) => {
  let show = true;

  switch (key) {
    case 'clients':
    case 'events':
    case 'boothNo':
    case 'registrationTypes':
      show = false;
    default:
    // nothing
  }

  const view = {
    show: show,
    menu: {
      caption: _.startCase(key),
      captionType: isList ? gEnums.captionTypes.fixed : gEnums.captionTypes.fromData,
    },
    layout: {
      layoutType: (key === 'events') ? gEnums.layoutTypes.icons : gEnums.layoutTypes.swipeable,
    },
    desktopLayout: {
      layoutType: (key === 'events') ? gEnums.layoutTypes.singlePage : gEnums.layoutTypes.singlePage,
    },
    viewItems: {
      [key]: viList,
    },
  }

  if (!isList) {
    view.menu.captionPage = key;
  }
  if (!isList) {
    if (_isPersonProps.includes(key)) {
      view.menu.captionProps = ['firstName', 'lastName'];
    } else {
      view.menu.captionProps = ['name'];
    }
  }
  return view;
};

const _createViews = (viewItems, existingViews, createClient, newProps) => {

  const views = {};

  viewItems = sortObjectRoot(viewItems);

  // loop  the viewItems
  Object.keys(viewItems).forEach(key => {

    let allow = false;

    if (existingViews) {
      if (!existingViews[key]) {
        allow = true;
      }
    } else {
      allow = true;
    }

    // if it does not already exist
    if (allow) {

      const viewItem = viewItems[key];

      if (!_.isObject(viewItem)) return;

      const dcn = viewItem?.dataSource?.dataCollectionName
      console.log('dcn', dcn)

      const opts = { forGlobal: false, count: 0, forList: false, existingViewItem: viewItem, newProps, dcn }
      const opts_l = { ...opts, forList: true }
      // create a view for normal and list

      views[key] = _createView(key, _createViewItem(key, opts));
      views[key + '_list'] = _createView(key, _createViewItem(key, opts_l), true);

      switch (key) {
        case 'clients':
          if (createClient) {
            Object.keys(viewItems).forEach((viKey, index) => {
              // for addtional
              const opts_a = { ...opts, existingViewItem: viewItems[viKey], count: index + 1, forAdditional: true, forMain: true }
              views[key].viewItems[viKey] = _createViewItem(viKey, c);
            });
          }
          break;

        case 'events':
          Object.keys(viewItems).forEach((viKey, index) => {
            switch (viKey) {
              case 'clients':
              case 'events':
              case 'boothNo':
                // case 'registrationTypes':
                // nothing
                break;
              default:
                const opts_a = { ...opts, existingViewItem: viewItems[viKey], count: index + 1, forAdditional: true, forMain: true }
                views[key].viewItems[viKey] = _createViewItem(viKey, opts_a);
            }
          });
          break;

        case 'attendees':
          // if attnedee, and a sessions to viewItems
          const opts_aa = { ...opts, existingViewItem: viewItems['sessions'], count: 1, forAdditional: true }
          views[key].viewItems['sessions'] = _createViewItem('sessions', opts_aa);
          break;

        case 'sessions':
          const opts_ss = { ...opts, existingViewItem: viewItems['attendees'], count: 1, forAdditional: true }
          views[key].viewItems['attendees'] = _createViewItem('attendees', opts_ss);
          break;
      }
    }
  });

  return views;
};

const _createViewItemProps = async (propsToAdd, existingProps, propSection) => {
  try {
    const newProps = await propsPromise(propsToAdd, propSection);
    if (newProps && existingProps) {
      _.forEach(newProps, (newProp => {
        newProp.position = _.size(existingProps)
        existingProps[newProp.key] = newProp
      }))
    }
    return newProps;
  } catch (error) {
    console.log('error', error)
  }
};

const propsPromise = async (propsToAdd, propSection, viewKeys) => {
  const promises = [];
  if (propsToAdd) {
    Object.keys(propsToAdd).forEach(np => {
      promises.push(_createViewItemProp(np, propSection, null, null, null, viewKeys));
    });
  }
  return Promise.all(promises);
};

const _createViewItemPropSections = async (name, count, propSections, viKey) => {
  let propSection;
  const show = _sectionHides(viKey, name);
  const showDesktop = _sectionHides(viKey, name);

  const psCount = propSections ? Object.keys(propSections).length : count;

  switch (name) {
    case 'name':
      propSection = {
        show: show,
        showDesktop: showDesktop,
        position: psCount,
        sectionHeader: {
          caption: _.startCase(name),
          headerDisplayType: gEnums.sectionBodyTypes.header,
        },
      };
      break;

    default:
      propSection = {
        show: show,
        showDesktop: showDesktop,
        position: psCount,
        sectionHeader: {
          caption: _.startCase(name),
          headerDisplayType: gEnums.sectionHeaderTypes.divider,
        },
        sectionBody: {
          bodyDisplayType: gEnums.sectionBodyTypes.table,
        },
      };
  }
  if (propSections) {
    propSections[name] = propSection;
  }

  return propSection;
  // return
};

const _ammendSectionName = (pk) => {
  if (_sectionProps.address.includes(pk)) {
    return 'address';
  }
  if (_sectionProps.contact.includes(pk)) {
    return 'contact';
  }
  if (_sectionProps.description.includes(pk)) {
    return 'description';
  }
  if (_sectionProps.hidden.includes(pk)) {
    return 'hidden';
  }
  if (_sectionProps.image.includes(pk)) {
    return 'image';
  }
  if (_sectionProps.location.includes(pk)) {
    return 'location';
  }
  if (_sectionProps.name.includes(pk)) {
    return 'name';
  }
  if (_sectionProps.schedule.includes(pk)) {
    return 'schedule';
  }
  if (_sectionProps.social.includes(pk)) {
    return 'social';
  }
  if (_sectionProps.travel.includes(pk)) {
    return 'travel';
  }
  if (_sectionProps.tags.includes(pk)) {
    return 'tags';
  }
  if (pk.startsWith('_')) {
    return 'hidden';
  }
  return 'details';
}

const _createViewItemPropSection = (name, count, propSections, viKey, returnResult) => {
  let propSection;
  const show = _sectionHides(viKey, name);
  const showDesktop = _sectionHides(viKey, name);

  const psCount = propSections ? Object.keys(propSections).length : count;

  switch (name) {
    case 'name':
      propSection = {
        show: show,
        showDesktop: showDesktop,
        position: psCount,
        sectionHeader: {
          caption: _.startCase(name),
          headerDisplayType: gEnums.sectionBodyTypes.header,
        },
      };
      break;

    default:
      propSection = {
        show: show,
        showDesktop: showDesktop,
        position: psCount,
        sectionHeader: {
          caption: _.startCase(name),
          headerDisplayType: gEnums.sectionHeaderTypes.divider,
        },
        sectionBody: {
          bodyDisplayType: gEnums.sectionBodyTypes.table,
        },
      };
  }
  if (propSections) {
    propSections[name] = propSection;
  }

  return propSection;
  // return
};

const _sectionHides = (viKey, name) => {
  if (viKey) {
    switch (viKey) {
      case 'attendees':
        switch (name) {
          case 'contactInfo':
          case 'details':
          case 'name':
          case 'other':
          case 'section1':
            return true;
          case 'hidden':
            return true;
          default:
            if (name.toLowerCase().indexOf('info') < 0) {
              return false;
            }
          // nothing
        }
        break;
      default:
      // nothing
    }
  }
  return true;
};

const _getCardDisplayType = (viKey, forList, forAdditional) => {
  switch (viKey) {
    case 'attendees':
    case 'panalists':
    case 'speakers':
    case 'staff':
      return forList || forAdditional ? gEnums.cardDisplayTypes.profile : gEnums.cardDisplayTypes.profilePlus;
    case 'sessions':
    case 'events':
      return forList || forAdditional ? gEnums.cardDisplayTypes.schedule : gEnums.cardDisplayTypes.schedulePlus;
    default:
      return (forList || forAdditional) ? gEnums.cardDisplayTypes.nameSectionOnly : gEnums.cardDisplayTypes.normal;
  }
};

const _getUniqueProps = (viKey) => {
  if (_isPersonProps.includes(viKey)) {
    return ['firstName', 'lastName', 'email'];
  } else {
    switch (viKey) {
      case 'sessions':
      case 'agenda':
        return ['name', 'startDate', 'startTime'];
      default:
        return ['name'];
    }
  }
};

const _createViewItemProp = (key, propSection, isList, count, fieldName, viewKeys) => {

  let formItemType = isList ? gEnums.formItemTypes.dropdown : gEnums.formItemTypes.text;

  const { _data = {} } = fieldName || {};

  let fixedList;

  if (fieldName) {
    switch (fieldName.type) {
      case 'textarea':
        formItemType = gEnums.formItemTypes.textArea;
        break;
      case 'email':
        formItemType = gEnums.formItemTypes.text;
        break;
      case 'dateselect':
        formItemType = gEnums.formItemTypes.date;
        break;
      case 'states':
        formItemType = gEnums.formItemTypes.select;
        fixedList = listTypes.usaStates;
        break;
      case 'countries':
        formItemType = gEnums.formItemTypes.select;
        fixedList = listTypes.countries;
        break;
      default:
      // nothing
    }
  }

  switch (key) {
    case 'description':
      formItemType = gEnums.formItemTypes.textArea;
      break;
    default:
    // nothing
  }

  if (!_data.formItemType) {
    _data.formItemType = formItemType;
    if (fixedList) {
      _data.fixedList = fixedList;
    }
  }

  let show = true;

  if (_sectionProps.hidden.includes(key)) {
    show = false;
  }
  if (viewKeys && viewKeys.includes(key)) {
    show = false;
  }
  if (key.endsWith('UTC')) {
    show = false;
  }
  if (key.startsWith('_')) {
    show = false;
  }

  const prop = {
    key,
    show: show,
    showDesktop: true,
    position: count ? count : 0,
    propSection,
    display: {
      caption: _.startCase(key),
      elemPropType: gEnums.elemPropTypes.normal,
    },
    data: _data,
  };

  if (isList) {
    prop.data.dataListType = gEnums.dataListTypes.dataList;
    prop.data.dataList = key;
  }

  if (fixedList) {
    prop.data.dataListType = gEnums.dataListTypes.fixed;
    prop.data.fixedList = fixedList;
  }

  if (!propSection) {
    propSection = _ammendSectionName(key);
  }

  if (_sectionProps.name.includes(key)) {
    prop.required = true;
    prop.header = true;
  }

  if (_sectionProps.schedule.includes(key)) {
    // @ts-ignore
    prop.schedule = true;
  }

  if (_sectionProps.tagged.includes(key)) {
    // @ts-ignore
    prop.tagged = true;
  }

  if (_sectionProps.pinned.includes(key)) {
    // @ts-ignore
    prop.pin = true;
  }

  return prop;
};